/**
 * useServiziCatalog + useAcquistaServizio — F-009.6 (lato agente).
 *
 * Catalogo servizi attivi + acquisto self-service. L'acquisto genera un
 * idempotencyKey per click (UUID) per evitare doppio addebito; su successo
 * invalida le query del wallet (saldo + storico aggiornati).
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { ServizioListResponse } from '@app/shared';

import {
  getServiziCatalog,
  acquistaServizio,
  acquistoErrorMessageFor,
} from '../lib/wallet-client';

export function useServiziCatalog() {
  return useQuery<ServizioListResponse>({
    queryKey: ['wallet', 'servizi-catalog'],
    queryFn: getServiziCatalog,
  });
}

export function useAcquistaServizio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (servizioId: string) => acquistaServizio(servizioId, crypto.randomUUID()),
    onSuccess: (data) => {
      toast.success(`"${data.servizio.nome}" acquistato. Saldo aggiornato.`);
      void qc.invalidateQueries({ queryKey: ['wallet'] });
    },
    onError: (err) => {
      toast.error(acquistoErrorMessageFor(err));
    },
  });
}
